import { useAtomValue } from "jotai";
import { questionnaireAddressModesAtom } from "../state/questionnaireAddressModesAtom";
import type { AddressModes } from "../types";

/**
 * Get address modes configuration (lookup/manual/none per address question).
 *
 * @example const addressModes = useAddressModes();
 */
export function useAddressModes(): AddressModes | undefined {
  return useAtomValue(questionnaireAddressModesAtom);
}
